// extracted by mini-css-extract-plugin
module.exports = {"name":"person-card_name__111E6","title":"person-card_title__3E8L1","desc":"person-card_desc__oEPyw"};